// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "rec-" + chunkId + "." + {"73":"014f9342","286":"ceefb1b5","302":"97527fd3","353":"f76c75a2","525":"9c65263d","626":"dd83d5f2","641":"ab84f734","814":"7c85bed1","927":"c02660ba"}[chunkId] + ".js";
};